import React from "react";
import { Navbar, Footer } from "@/components/yc/Nav";
import { CreatorAgreementText, AGREEMENT_VERSION } from "@/components/yc/CreatorAgreement";

const CreatorAgreementPage = () => (
    <div className="min-h-screen bg-yc-cream flex flex-col">
        <Navbar />
        <section className="flex-1 px-6 py-16">
            <div className="max-w-3xl mx-auto">
                <div className="yc-overline">Legal · {AGREEMENT_VERSION}</div>
                <div className="yc-card p-8 md:p-10 mt-4" data-testid="creator-agreement-page">
                    <CreatorAgreementText />
                </div>
            </div>
        </section>
        <Footer />
    </div>
);

export default CreatorAgreementPage;
